import React, { useEffect, useState } from "react";
import { SCDocumentacionModal } from "../../Dashboard/Clientes/CapturasDashClientes/DocumentadionSC/SCDocumentacionModal";
import Swal from "sweetalert2";
import { InputAdornment, TextField } from "@mui/material";
import request from "../../../Helpers/API";
import UpdateIcon from "@mui/icons-material/Update";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import SendIcon from '@mui/icons-material/Send';
// Icono para "Documento no requerido en esta solicitud" (accion "X").
import BlockIcon from '@mui/icons-material/Block';

export const AnalizarDocumentacionVigencia = ({
    folio,
    setLoader,
    loader,
    idproceso = 4,
}) => {
    const [openComentarios, setOpenComentarios] = useState(false);
    const [comentarios, setComentarios] = useState("");
    const [doctoselect, setDoctoSelect] = useState({
        iddocumento: "",
        documento: "",
        vencimiento: "",
    });
    const [accion, setAccion] = useState("");
    const [data, setData] = useState({
        estado: {},
        documentacion: [],
    });
    const onChange = (prop, value, sbool, smensaje) => {
        setComentarios(value);
    };
    useEffect(() => {
        onObtenerAnalisisDocumentacion();
    }, []);
    const onObtenerAnalisisDocumentacion = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ACDocumentacion/Get?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    documentacion: result.documentacion,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const OnGetIcon = ({ icon }) => {
        switch (icon) {
            case "wait":
                return <PendingIcon className="wait" />;
            case "success":
                return <CheckCircleIcon className="success" />;
            case "warning":
                return <WarningIcon className="warning" />;
            case "error":
                return <ErrorIcon className="error" />;
            default:
                <></>;
        }
    };
    const onImprimirArchivo = (iddocumento) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
                    iddocumento
                )}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = result.comentarios;
                const downloadLink = document.createElement("a");
                const fileName = `${result.documento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const onEnviarComentario = () => {
        const rescomentarios = ValFormReg(
            "Comentarios",
            comentarios,
            RegularExpressions.TextSpecialCharacter,
            15,
            2000
        );
        if (rescomentarios.isValid === false) {
            Swal.fire(
                "ANALISIS DE SOLICITUD DE CREDITO",
                rescomentarios.mensaje,
                "error"
            );
            return;
        }
        const hoy = new Date();
        const fechaVencimiento = new Date(doctoselect.vencimiento);
        if (accion === "A") {
            if (doctoselect.vencimiento === null || doctoselect.vencimiento === "" || doctoselect.vencimiento === undefined) {
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    "Favor de agregar una fecha de vencimiento para el documento",
                    "error"
                );
                return;
            }
            else if (fechaVencimiento < hoy) {
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    "La fecha no puede ser anterior a la actual",
                    "error"
                );
                return;
            }
        }

        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso,
            iddocumento: doctoselect.iddocumento,
            nombreDocumento: doctoselect.documento,
            consecutivo: -1,
            comentarios: `(${doctoselect.documento})=> ${comentarios}`,
            vencimiento: doctoselect.vencimiento,
            estatus: accion,
        };

        request
            .post("ACTimelineComentariosTask/EnviarAnalisisDocumentacion", post)
            .then((result) => {

                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    documentacion: result.documentacion,
                });
                setComentarios("");
                setOpenComentarios(false);
                setDoctoSelect({
                    iddocumento: "",
                    documento: "",
                    vencimiento: "",
                });

                Swal.fire(
                    "DOCUMENTACION",
                    "Respuesta enviada",
                    "success"
                );
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const onAceptar = (iddocumento) => {
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso,
            iddocumento: iddocumento,
            consecutivo: -1,
            comentarios: "DOCUMENTO APROBADO",
            estatus: "A",
        };
        request
            .post("ACTimelineComentariosTask", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    documentacion: result.documentacion,
                });
                setComentarios("");
                setOpenComentarios(false);
                setDoctoSelect({
                    iddocumento: "",
                    documento: "",
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const openModal = (documento, iddocumento) => {
        var modal = document.getElementById("modal-documentos");
        modal.style.display = "block";
        setDoctoSelect({
            documento,
            iddocumento,
        });
    };

    return (
        <div className="analisis-solicitud-credito-proceso">
            <SCDocumentacionModal
                folio={folio}
                documento={doctoselect.documento}
                iddocumento={doctoselect.iddocumento}
                loader={loader}
                setLoader={setLoader}
                setdocumento={setDoctoSelect}
                setdocumentos={onObtenerAnalisisDocumentacion}
                cargar={true}
            />
            <div className="analisis-solicitud-credito-proceso-container scroll-4">
                {data.documentacion === undefined ||
                    data.documentacion === null ||
                    data.documentacion.length === 0 ? (
                    <div></div>
                ) : (
                    <table cellPadding={0} cellSpacing={0}>
                        <thead>
                            <tr>
                                <th>Documento</th>
                                <th>Descargar</th>
                                <th>Aceptar</th>
                                <th>Modificar</th>
                                <th>No Aplica</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.documentacion.map((doc) => (
                                <tr>
                                    <td>{doc.documento}</td>
                                    <td>
                                        {doc.tiene_documentacion === true ? (
                                            <div onClick={() => onImprimirArchivo(doc.iddocumento)}>
                                                <CloudDownloadIcon />
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </td>
                                    {doc.habilitar === false &&
                                        (doc.icono === "success" || doc.icono === "error") ? (
                                        data.estado.habilitar === false ? (
                                            <>
                                                {/* <td className="update-documento-analisis">
                                                    <div
                                                        onClick={() =>
                                                            openModal(doc.documento, doc.iddocumento)
                                                        }
                                                    >
                                                        <UpdateIcon />
                                                        Actualizar
                                                    </div>
                                                </td> */}
                                                <td
                                                    colSpan={3}
                                                    className="analianalisis-solicitud-credito-procesos-comentarios"
                                                >
                                                    <OnGetIcon icon={doc.icono} />
                                                    {doc.comentarios}
                                                </td>
                                            </>
                                        ) : (
                                            <>
                                                <td
                                                    // colSpan={2}
                                                    className="analianalisis-solicitud-credito-procesos-comentarios"
                                                >
                                                    <OnGetIcon icon={doc.icono} />
                                                    {/* {doc.comentarios} */}
                                                </td>
                                                <td>
                                                    <div
                                                        onClick={() => {
                                                            setOpenComentarios(!openComentarios);
                                                            setDoctoSelect({
                                                                ...doctoselect,
                                                                iddocumento: doc.iddocumento,
                                                                documento: doc.documento,
                                                            });
                                                            setComentarios("");
                                                            setAccion("M");
                                                        }}
                                                    >
                                                        <WarningIcon />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        title="Este documento no se pide en esta solicitud"
                                                        onClick={() => {
                                                            setOpenComentarios(!openComentarios);
                                                            setDoctoSelect({
                                                                ...doctoselect,
                                                                iddocumento: doc.iddocumento,
                                                                documento: doc.documento,
                                                            });
                                                            setComentarios("");
                                                            setAccion("X");
                                                        }}
                                                    >
                                                        <BlockIcon />
                                                    </div>
                                                </td>
                                            </>


                                        )
                                    ) : (
                                        data.estado.habilitar === false ? (
                                            <>
                                                <td className="update-documento-analisis">
                                                    <div
                                                        onClick={() =>
                                                            openModal(doc.documento, doc.iddocumento)
                                                        }
                                                    >
                                                        <UpdateIcon />
                                                        Actualizar
                                                    </div>
                                                </td>
                                                <td
                                                    colSpan={3}
                                                    className="analianalisis-solicitud-credito-procesos-comentarios"
                                                >
                                                    <OnGetIcon icon={doc.icono} />
                                                    {doc.comentarios}
                                                </td>
                                            </>
                                        ) : (
                                            <>
                                                <td>
                                                    <div
                                                        onClick={() => {
                                                            setOpenComentarios(!openComentarios);
                                                            setDoctoSelect({
                                                                ...doctoselect,
                                                                iddocumento: doc.iddocumento,
                                                                documento: doc.documento,
                                                            });
                                                            setComentarios("");
                                                            setAccion("A");
                                                        }}
                                                    >
                                                        <CheckCircleIcon />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        onClick={() => {
                                                            setOpenComentarios(!openComentarios);
                                                            setDoctoSelect({
                                                                ...doctoselect,
                                                                iddocumento: doc.iddocumento,
                                                                documento: doc.documento,
                                                            });
                                                            setComentarios("");
                                                            setAccion("M");
                                                        }}
                                                    >
                                                        <WarningIcon />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        title="Este documento no se pide en esta solicitud"
                                                        onClick={() => {
                                                            setOpenComentarios(!openComentarios);
                                                            setDoctoSelect({
                                                                ...doctoselect,
                                                                iddocumento: doc.iddocumento,
                                                                documento: doc.documento,
                                                            });
                                                            setComentarios("");
                                                            setAccion("X");
                                                        }}
                                                    >
                                                        <BlockIcon />
                                                    </div>
                                                </td>
                                            </>
                                        )
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            <div className="analisis-solicitud-credito-proceso-footer scroll-4">
                {openComentarios && (
                    <div className="respuesta-documento-container">
                        {accion === "A" && (
                            <TextField
                                className="vencimiento"
                                id="date"
                                label="VENCIMIENTO"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                sx={{ mt: 2 }}
                                // error={state.bvencimiento}
                                onChange={({ target }) =>
                                    setDoctoSelect({ ...doctoselect, vencimiento: target.value })
                                }
                                value={doctoselect.vencimiento}
                            />
                        )}

                        <TextField
                            fullWidth
                            size="small"
                            label={doctoselect.documento}
                            className="w-80"
                            multiline
                            rows={3}
                            type="text"
                            // error={condiciones.bcondiciones}
                            onChange={({ target }) => {
                                ValSpecialCharacters(
                                    "comentarios",
                                    target.value,
                                    onChange,
                                    true,
                                    500
                                );
                            }}
                            value={comentarios}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        <SendIcon
                                            className="boton-enviar-aceptar"
                                            onClick={() => onEnviarComentario()}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
